import {CommandContainer} from './type';

export default function latestCommand(commands: Array<CommandContainer<any> | null>) {
  const onlyCommands = commands
    .filter(c => c !== null) as Array<CommandContainer<any>>;

  return onlyCommands
    .sort((a, b) => a.timestamp < b.timestamp ? -1 : a.timestamp > b.timestamp ? 1 : 0)
    [0] || null;
}